<template>
  <Modal
    v-model="state"
    title="iOS下架监控提醒"
    width="666"
    class-name="c-modal vertical-center-modal"
    :mask-closable="false"
    :closable="false"
    @on-visible-change="bindGetData"
  >
    <Spin fix v-if="loading"></Spin>

    <Row>
      <!-- 应用 -->
      <Col span="12">
        <Card dis-hover class="c-left">
          <template #title>应用</template>
          <div class="c-form">
            <Form :label-width="50" inline>
              <FormItem :label-width="0">
                <div>
                  <el-select
                    v-model="appIds"
                    multiple
                    placeholder="请选择应用名称"
                    collapse-tags
                    filterable
                    clearable
                    :popper-append-to-body="false"
                    style="overflow: hidden"
                    class="calc-width"
                  >
                    <el-option v-for="item in iOSAppData" :key="item.id" :value="item.id" :label="item.name" class="calc-width"></el-option>
                  </el-select>
                </div>
              </FormItem>
              <FormItem :label-width="0" style="margin: 0">
                <Button type="primary" size="small" style="margin-bottom: 1px" @click="addApp">添加</Button>
              </FormItem>
            </Form>
          </div>
          <Table size="small" border ellipsis tooltip height="355" :columns="appColumns" :data="selectApp">
            <template #control="{ row }">
              <el-button type="text" size="small" @click="delApp(row.id)">删除</el-button>
            </template>
          </Table>
        </Card>
      </Col>

      <!-- 人员 -->
      <Col span="12">
        <Card dis-hover class="c-right">
          <template #title>人员</template>
          <div class="c-form">
            <Form :label-width="50" inline>
              <FormItem :label-width="0">
                <div>
                  <el-select
                    v-model="opIds"
                    multiple
                    placeholder="请选择人员名称"
                    collapse-tags
                    filterable
                    clearable
                    :popper-append-to-body="false"
                    style="overflow: hidden"
                    class="calc-width"
                  >
                    <el-option v-for="item in SYS_USERS" :key="item.id" :value="item.id" :label="item.name" class="calc-width"></el-option>
                  </el-select>
                </div>
              </FormItem>
              <FormItem :label-width="0" style="margin: 0">
                <Button type="primary" size="small" style="margin-bottom: 1px" @click="addOp">添加</Button>
              </FormItem>
            </Form>
          </div>
          <Table size="small" border ellipsis tooltip height="355" :columns="opColumns" :data="selectOp">
            <template #control="{ row }">
              <el-button type="text" size="small" @click="delOp(row.id)">删除</el-button>
            </template>
          </Table>
        </Card>
      </Col>
    </Row>
    <template slot="footer">
      <div class="m-foot">
        <Button @click="closeModal" :disabled="btlLoading">取消</Button>
        <Button type="primary" :loading="btlLoading" @click="submit">
          <span v-if="btlLoading">保存中...</span>
          <span v-else>保存</span>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { isArray } from '@/common/js/utils'
import { queryiOSTakeDownConfig, saveiOSTakeDownConfig } from '@/api/track.plan.model'
import { initPageData, SYS_USERS, POPULAR_GAMES } from '@/data/global-opts'

const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, POPULAR_GAMES])

export default {
  name: 'iOSTakeDown',
  props: {
    value: {
      type: Boolean
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS,
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    iOSAppData() {
      return this.POPULAR_GAMES.filter((ret) => ret.ch_platform_id === 2)
    }
  },
  methods: {
    bindGetData(e) {
      if (e) {
        this.preload()
        return
      }
      this.selectApp = []
      this.selectOp = []
      this.appIds = []
      this.opIds = []
    },
    addApp() {
      if (isArray(this.appIds)) {
        const exitApps = this.selectApp.map((ret) => ret.id)
        const invalidiOSApp = this.POPULAR_GAMES.filter((ret) => this.appIds.includes(ret.id) && !exitApps.includes(ret.id)).filter(
          (ret) =>
            !ret.game_address ||
            !(ret.game_address.indexOf('https://apps.apple.com') === 0 || ret.game_address.indexOf('https://itunes.apple.com') === 0)
        )
        if (invalidiOSApp.length) {
          const appNames = invalidiOSApp.map((ret) => ret.name).join('、')
          this.$Message.warning(`请检查游戏下载链接是否配置正确：${appNames}`)
          return
        }
        this.selectApp.push(
          ...this.POPULAR_GAMES.filter((ret) => this.appIds.includes(ret.id) && !exitApps.includes(ret.id)).map((ret) => {
            return {
              id: ret.id,
              name: ret.name
            }
          })
        )
        this.appIds = []
      }
    },
    addOp() {
      if (isArray(this.opIds)) {
        const exitOps = this.selectOp.map((ret) => ret.id)
        this.selectOp.push(
          ...this.SYS_USERS.filter((ret) => this.opIds.includes(ret.id) && !exitOps.includes(ret.id)).map((ret) => {
            return {
              id: ret.id,
              name: ret.name
            }
          })
        )
        this.opIds = []
      }
    },
    delApp(id) {
      const index = this.selectApp.findIndex((ret) => ret.id === id)
      this.selectApp.splice(index, 1)
    },
    delOp(id) {
      const index = this.selectOp.findIndex((ret) => ret.id === id)
      this.selectOp.splice(index, 1)
    },
    preload() {
      this.loading = true
      queryiOSTakeDownConfig().then((data) => {
        this.loading = false
        if (data) {
          const { gameIds, opIds } = data
          this.selectApp = gameIds || []
          this.selectOp = opIds || []
        }
      })
    },
    submit() {
      const params = {
        gameIds: this.selectApp.map((ret) => ret.id),
        opIds: this.selectOp.map((ret) => ret.id)
      }
      this.btlLoading = true
      saveiOSTakeDownConfig(params).then((data) => {
        this.btlLoading = false
        if (data) {
          this.closeModal()
          this.$Message.success('保存成功')
        }
      })
    },
    closeModal() {
      this.$emit('input', false)
    }
  },
  data() {
    return {
      loading: false,
      btlLoading: false,
      appIds: '',
      opIds: '',
      appColumns: [
        { title: '应用名称', key: 'name', ellipsis: true, tooltip: true, width: 188.34 },
        { title: '操作', slot: 'control' }
      ],
      opColumns: [
        { title: '人员名称', key: 'name', ellipsis: true, tooltip: true, width: 188.34 },
        { title: '操作', slot: 'control' }
      ],
      selectApp: [],
      selectOp: []
    }
  }
}
</script>

<style lang="scss" scoped>
.c-modal {
  position: relative;

  .c-form {
    width: 100%;
    flex: auto;
    display: flex;
    justify-content: left;
    margin-bottom: 8px;

    ::v-deep .ivu-form-item {
      margin-bottom: 0;
      text-align: left;
      height: 32px;
    }

    ::v-deep .el-input__inner {
      height: 24px !important;
      line-height: 24px !important;
    }
  }

  .calc-width {
    width: calc(283px - 53px) !important;
  }
}

/* 多选内容太长截断 */
::v-deep .el-tag {
  max-width: 110px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
}

.c-left {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.c-right {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-left: 0px;
}

::v-deep .ivu-table-tip {
  width: calc(100% + 0.5px) !important;
}
</style>
